import { cloneDeep } from 'lodash';
import Actions from '../actions/actions';
import DomainActions from '../actions/DomainCRUDActions';
import DomainModel from '../model/DomainModel';
import { addEntity, setBusy, setUnBusy } from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [] as DomainModel[],
};

const domain = (state = initialState, action) => {
  switch (action.type) {
    case DomainActions.busyAction:
      return setBusy(state);
    case DomainActions.retrievedAction:
      return addEntity(state, action);
    case DomainActions.updateAction: {
      const newState = cloneDeep(state);
      const { connectedPageId, domainsList } = action.entity;

      const index = newState.entities.findIndex(
        e => e.connectedPageId === connectedPageId,
      );

      newState.busy = false;

      if (newState.entities[index]) {
        newState.entities[index].domainsList = domainsList;
      }

      return newState;
    }

    case DomainActions.unbusyAction:
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};

export default domain;
